const saveTableNameToLocalStorage = (tableName) => {
  const overwriteDetails = JSON.stringify({ tableName: { value: tableName, label: tableName } });

  window.sessionStorage.setItem('detailsForm', overwriteDetails);
};

export default saveTableNameToLocalStorage;
